import { TONES } from "../../../../src/shared/constants";

export type WriteSuggestionCardHeaderMode = "auto" | "guided" | "tone";

export type WriteSuggestionCardHeaderConfig = {
  mode: WriteSuggestionCardHeaderMode;
  toneValue?: string | null;
};

export type WriteSuggestionCardHeader = {
  iconSrc: string;
  label: string;
};

const WRITE_SUGGESTION_HEADER_ICONS: Record<WriteSuggestionCardHeaderMode, string> = {
  auto: "/assets/quill.svg",
  guided: "/assets/guided-arrows.svg",
  tone: "/assets/tone.svg",
};

export function normalizeWriteSuggestionCardHeaderMode(
  value: unknown,
): WriteSuggestionCardHeaderMode {
  if (value === "guided" || value === "tone" || value === "auto") return value;
  return "auto";
}

export function resolveToneLabelForWriteSuggestionCard(toneValue?: string | null): string {
  const normalized = typeof toneValue === "string" ? toneValue.trim().toLowerCase() : "";
  if (!normalized) return "TONE";
  const matchedTone = TONES.find((tone) => tone.value === normalized);
  if (matchedTone?.label) return matchedTone.label.toUpperCase();
  return normalized
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ")
    .toUpperCase();
}

export function getWriteSuggestionCardHeader(
  config: WriteSuggestionCardHeaderConfig,
  optionIndex: number,
  totalSuggestions = 1,
): WriteSuggestionCardHeader {
  const mode = normalizeWriteSuggestionCardHeaderMode(config.mode);
  const iconSrc = WRITE_SUGGESTION_HEADER_ICONS[mode];
  if (mode === "tone") {
    return {
      iconSrc,
      label: resolveToneLabelForWriteSuggestionCard(config.toneValue),
    };
  }
  if (mode === "guided") {
    return { iconSrc, label: "GUIDED" };
  }
  return {
    iconSrc,
    label: totalSuggestions <= 1 ? "SUGGESTION" : `OPTION ${Math.max(1, optionIndex + 1)}`,
  };
}
